/* eslint-disable react-hooks/exhaustive-deps */
import { FileFormats } from "@repo/design-system/components/forms/libs";
import { Button, ButtonVariant, Iconify } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import "./FileUpload.scss";
import FilePreview from './filePreview/FilePreview';

const FileUpload = ({
  name = "",
  onClear,
  isDisable,
  onChange,
  onClearAll,
  fieldSetting,
  onActionClick,
  isDownloadButton,
  selectedFileValues,
  isMultipleFileAllowed = false,
  isShowCustomPreview = true,
  acceptedFileFormats = FileFormats.ALL,
}) => {
  const [fileValues, setFileValues] = useState(selectedFileValues);

  const fileRef = useRef();

  const handleInputChange = (e) => {
    if (e.target.files?.length > 0) {
      onChange?.(e);
    } else {
      handleClearClick();
    }
  };

  const handleActionClick = (index, action) => {
    onActionClick?.(index, action);
  };

  const handleClearClick = (index) => {
    if (fileRef.current) {
      fileRef.current.value = null;
    }
    if (index !== undefined) {
      const newFileValues = [...fileValues];
      newFileValues.splice(index, 1);
      setFileValues(newFileValues);
      if (onClear) onClear(index);
    }
  };

  const handleClearAll = () => {
    fileRef.current.value = null;
    setFileValues([]);
    onClearAll?.();
  };

  const handleUploadBtnClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    fileRef.current?.click();
  };

  useEffect(() => {
    if (selectedFileValues?.length > 0 && Array.isArray(selectedFileValues)) {
      setFileValues(selectedFileValues.map((file) => file.file));
    } else {
      setFileValues([]);
      handleClearClick();
    }
  }, [selectedFileValues]);

  return (
    <>
      <div className="file-uploader">
        {(isMultipleFileAllowed || fileValues?.length === 0) && (
          <>
            <input
              ref={fileRef}
              id={name}
              name={name}
              disabled={isDisable}
              type="file"
              className="file-input"
              onChange={handleInputChange}
              // onBlur={onBlur}
              accept={acceptedFileFormats}
              multiple={isMultipleFileAllowed}
            />
            <div className="custom-file-selector-design">
              <Iconify icon="fa-solid:upload" className={isDisable ? 'disable' : ''} />

              <div className={`drag-drop-txt ${isDisable ? 'disable' : ''}`}>
                <p>Drag & Drop Your File</p>
                <span className="small-txt">
                  {acceptedFileFormats.length > 0 && acceptedFileFormats.join(", ")}&nbsp;
                  Formats we support
                </span>
                <br></br>
                <span className="small-txt">
                  {fieldSetting?.minFileSizeInMB >= 0 &&
                    <>
                      Min:{" "} <span className="fw-bold">{fieldSetting?.minFileSizeInMB} MB</span> & {" "}
                    </>
                  }
                  {fieldSetting?.maxFileSizeInMB &&
                    <>Max:{" "} <span className="fw-bold">{fieldSetting?.maxFileSizeInMB} MB</span></>}
                </span>
              </div>

              {/* <div className="buttons">
                <Button variant={ButtonVariant.SECONDARY} rightIcon="mynaui:upload" className="upload-button"
                  onClick={handleUploadBtnClick} disabled={isDisable}>Upload</Button>
              </div> */}
            </div>
          </>
        )}

        {!isMultipleFileAllowed && fileValues.length > 0 ? (
          <FilePreview
            fileValues={fileValues}
            isDisable={isDisable}
            isShowCustomPreview={isShowCustomPreview}
            onClearAll={handleClearAll}
            onClearClick={handleClearClick}
            isDownloadButton={isDownloadButton}
            fieldSetting={fieldSetting}
            onActionClick={handleActionClick}
            isMultipleFileAllowed={isMultipleFileAllowed}
            selectedFileObj={selectedFileValues}
          />
        ) : null}
      </div>
      {isMultipleFileAllowed && fieldSetting.isPreviewAllowed && fileValues ? (
        <FilePreview
          fileValues={fileValues}
          isDisable={isDisable}
          onClearAll={handleClearAll}
          onClearClick={handleClearClick}
          isDownloadButton={isDownloadButton}
          fieldSetting={fieldSetting}
          onActionClick={handleActionClick}
          isMultipleFileAllowed={isMultipleFileAllowed}
          selectedFileObj={selectedFileValues}
        />
      ) : null}
    </>
  );
};

FileUpload.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  onClearAll: PropTypes.func,
  placeholder: PropTypes.string,
  isDisable: PropTypes.bool,
  fieldSetting: PropTypes.shape({
    minFileSizeInMB: PropTypes.number,
    maxFileSizeInMB: PropTypes.number,
    isPreviewAllowed: PropTypes.bool,
    isShowCustomPreview: PropTypes.bool
  }),
  onActionClick: PropTypes.func,
  selectedFileValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  isDownloadButton: PropTypes.bool,
  isMultipleFileAllowed: PropTypes.bool,
  acceptedFileFormats: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

export default FileUpload;
